module.exports = __webpack_public_path__ + "img/SSM_w_trans.b69b7a2a.png";